import { Button } from "components/Button";
import { ClariahLink } from "components/ClariahLink";
import {
  LAPOSTA_NEWSLETTER_FORM_URL,
  TYPE_RICHTEXT_SIMPLE,
  PAGE_TYPE,
  SMALL,
} from "shared/constants";
import { MaxWidth } from "components/MaxWidth";
import { Spacing } from "components/Spacing";
import { RichText } from "components/RichText";
import { useRouter } from "next/router";
import { useState } from "react";
import {
  NEWSLETTER_TITLE,
  NEWSLETTER_SUBTEXT,
  NEWSLETTER_PRIVACY_STATEMENT,
  YOUR_EMAIL_ADDRESS,
  SUBSCRIBE,
  translate,
} from "shared/translate";
import styles from "./NewsletterSection.module.css";

export const NewsletterSection = () => {
  const { locale } = useRouter();

  return (
    <div className={styles.container}>
      <MaxWidth>
        <h2 className={styles.title}>{translate(NEWSLETTER_TITLE, locale)}</h2>
        <NewsletterForm />
        <div className={styles.richTextContainer}>
          <RichText type={TYPE_RICHTEXT_SIMPLE}>
            {translate(NEWSLETTER_SUBTEXT, locale)}{" "}
            <ClariahLink type={PAGE_TYPE} href="privacy">
              {translate(NEWSLETTER_PRIVACY_STATEMENT, locale)}
            </ClariahLink>
            .
          </RichText>
        </div>
      </MaxWidth>
    </div>
  );
};

const NewsletterForm = () => {
  const { locale } = useRouter();
  const [email, setEmail] = useState("");

  function onSubmit(e) {
    e.preventDefault();

    Object.assign(document.createElement("a"), {
      target: "_blank",
      href: `${LAPOSTA_NEWSLETTER_FORM_URL}&email=${email}`,
      rel: "noopener noreferrer",
    }).click();
  }

  return (
    <div>
      <form onSubmit={onSubmit} className={styles.form}>
        <input
          className={styles.input}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={translate(YOUR_EMAIL_ADDRESS, locale)}
          required
          type="email"
          value={email}
          aria-label={translate(YOUR_EMAIL_ADDRESS, locale)}
        />
        <Button buttonType="submit">{translate(SUBSCRIBE, locale)}</Button>
      </form>
    </div>
  );
};

export const NewsletterSectionContainer = () => (
  <Spacing size={SMALL}>
    <NewsletterSection />
  </Spacing>
);
